module.exports = __webpack_public_path__ + "fe47d0daf593412a368603a584c98326.svg";